import { createSlice } from '@reduxjs/toolkit';
import { setCookie } from '@/libs/utils/cookie-tool';

/**
 * 账号权限信息
 * @typedef {Object} AuthInfo
 * @property {number} vip - VIP 等级（如 2 表示校园版）
 * @property {string} account_type - 账号类型描述，如"校园账号"
 * @property {number} left_valid_time - 剩余有效天数
 */

/**
 * 积分/额度信息
 * @typedef {Object} QuotaInfo
 * @property {number} total_balance - 当前可用积分余额
 */

/**
 * 用户完整数据
 * @typedef {Object} UserData
 * @property {string} account - 用户账号（手机号/邮箱等）
 * @property {number} company_auth - 企业认证状态
 * @property {string} company_name - 企业/学校名称
 * @property {AuthInfo} authInfo - 账号权限信息
 * @property {QuotaInfo} quotaInfo - 积分/额度信息
 * @property {string} real_name - 真实姓名
 * @property {string | null} school - 学校名称，未填写时为 null
 * @property {string | null} intro - 个人简介，未填写时为 null
 * @property {string | null} email - 邮箱，未填写时为 null
 * @property {string} headimg - 头像链接，无头像时为空字符串
 * @property {string} role - 用户角色，如"教师"
 * @property {string} join_time - 加入时间，如"2025年3月"
 */

/**
 * 用户模块初始状态
 * @typedef {Object} UserState
 * @property {UserData} data - 用户完整数据
 * @property {string} uuid - 设备/会话 UUID
 * @property {string} uid - 用户唯一标识
 * @property {string} accountType - 账号类型
 */

/** @type {UserState} */
const initData = {
  data: {},
  uuid: '',
  uid: '',
  accountType: '',
};

const userReducers = createSlice({
  name: 'users',
  initialState: initData,
  reducers: {
    setUUID(state, action) {
      state.uuid = action.payload;
    },
    setUID(state, action) {
      state.uid = action.payload;
    },
    setUserData(state, action) {
      state.data = action.payload;
    },
    setAccountType(state, action) {
      state.accountType = action.payload;
    },
    clearUserData() {
      // 清空用户数据
      setCookie('uuid', '', 0);
      localStorage.removeItem('uid');
      localStorage.removeItem('userData');
      return initData;
    },
  },
});

export const { setUUID, setUID, setUserData, setAccountType, clearUserData } =
  userReducers.actions;

export default userReducers.reducer;
